export const RESET = 'PRODUCTSTATUS_UPDATE_RESET'
export const SET_ERROR = 'PRODUCTSTATUS_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'PRODUCTSTATUS_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'PRODUCTSTATUS_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'PRODUCTSTATUS_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'PRODUCTSTATUS_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'PRODUCTSTATUS_UPDATE_UPDATE_RETRIEVED'
